export default "__VITE_ASSET__c777d3fc__"